import React from "react";
import PropTypes from "prop-types";
import { UIDatePicker } from "../../../ui";
import { clx } from "../../../../utils/Helpers";

import "./_TimelineGroup.scss";

const TimelineGroup = ({
  title,
  icon,
  startName,
  endName,
  labels,
  required,
  classNames,
  disablePast,
  disabled,
}) => (
  <div
    className={clx(
      "timeline-group",
      { "timeline-group--active": required },
      classNames?.root,
    )}
  >
    <div className={clx("timeline-group__title", classNames?.title)}>
      {icon}
      <span>
        {title}
        {required && <span className="text-danger">*</span>}
      </span>
    </div>
    <UIDatePicker
      name={startName}
      label={labels.start}
      placeholder={labels.startPlaceholder}
      required={required}
      withTime
      disablePast={disablePast}
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
    />
    <UIDatePicker
      name={endName}
      label={labels.end}
      placeholder={labels.endPlaceholder}
      required={required}
      withTime
      disablePast={disablePast}
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
    />
  </div>
);

export default TimelineGroup;

TimelineGroup.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  startName: PropTypes.string.isRequired,
  endName: PropTypes.string.isRequired,
  labels: PropTypes.object.isRequired,
  required: PropTypes.bool,
  classNames: PropTypes.object,
  disablePast: PropTypes.bool,
  disabled: PropTypes.bool,
};

TimelineGroup.defaultProps = {
  classNames: {},
  disablePast: true,
  disabled: false,
};
